import { CommonUtils } from "WorkCustomization/Scripts/Utils/CommonUtils";
import { CoreFieldRefNames, OobFieldRefNames } from "Presentation/Scripts/TFS/Generated/TFS.WorkItemTracking.Constants";
import  ProcessContracts = require("TFS/WorkItemTracking/ProcessContracts");
import { RuleCondition, RuleConditionType, RuleActionType, ProcessRule, UpdateProcessRuleRequest} from "TFS/WorkItemTracking/ProcessContracts";
import StringUtils = require("VSS/Utils/String");


export namespace RuleUtils {
    export const getClone = (rule: ProcessRule): ProcessRule => {
        rule = {
            actions: rule.actions,
            conditions: rule.conditions,
            name: rule.name, // THE ORDER OF THESE FIELDS NEEDS TO MATCH FIELDRULEMODEL FOR TOJSON ISDIRTY CHECK TO WORK
            id: rule.id,
            isDisabled: rule.isDisabled,
            customizationType: rule.customizationType,
            url : rule.url
        };

        return JSON.parse(JSON.stringify(rule));
    }

    export const cloneUpdateProcessRuleRequest = (rule: UpdateProcessRuleRequest): UpdateProcessRuleRequest => {
        rule = {
            actions: rule.actions,
            conditions: rule.conditions,
            name: rule.name, 
            isDisabled: rule.isDisabled,
            id: rule.id,
        };
        return JSON.parse(JSON.stringify(rule));
    }

    export const getNewRule = (id?: string): ProcessRule => {
        const emptyRule: ProcessRule = {
            actions: [{
                actionType: null,
                targetField: "",
                value: ""
            }],
            conditions: [{
                conditionType: null,
                field: "",
                value: ""
            }],
            name: "",
            id: id ? id : "",
            isDisabled: false,
            customizationType: ProcessContracts.CustomizationType.Custom,
            url : ""
        };
        return emptyRule;
    }


    export const translateClientRuleToServerRule = (clientRule: ProcessRule): ProcessRule => {
        if (!clientRule.conditions) {
            return clientRule;
        }

        // clone before modification
        clientRule = CommonUtils.getClone<ProcessRule>(clientRule);

        let whenStateChangedToConditionIndex: number;
        let whenStateChangedFromAndToConditionIndex: number;
        let whenWorkItemCreatedIndex: number;
        let whenValueIsDefinedIndex: number;
        let whenValueIsNotDefinedIndex: number;

        for (let i = 0; i < clientRule.conditions.length; i++) {

            switch (clientRule.conditions[i].conditionType) {
                case RuleConditionType.WhenStateChangedTo:
                    whenStateChangedToConditionIndex = i;
                    break;
                case RuleConditionType.WhenStateChangedFromAndTo:
                    whenStateChangedFromAndToConditionIndex = i;
                    break;
                case RuleConditionType.WhenWorkItemIsCreated:
                    whenWorkItemCreatedIndex = i;
                    break;
                case RuleConditionType.WhenValueIsDefined:
                    whenValueIsDefinedIndex = i;
                    break;
                case RuleConditionType.WhenValueIsNotDefined:
                    whenValueIsNotDefinedIndex = i;
                    break;
                // Else nothing to do
            }
        }

        if (whenValueIsDefinedIndex != null) {
            clientRule.conditions[whenValueIsDefinedIndex].conditionType = RuleConditionType.WhenNot;
        }
        if (whenValueIsNotDefinedIndex != null) {
            clientRule.conditions[whenValueIsNotDefinedIndex].conditionType = RuleConditionType.When;
        }

        if (whenStateChangedFromAndToConditionIndex != null) {
            // '.' is not allowed in a state name, so we use it to cram in two values in our client side translation code
            const parts: string[] = clientRule.conditions[whenStateChangedFromAndToConditionIndex].value.split('.');
            const whenWasCondition: RuleCondition = {
                conditionType: RuleConditionType.WhenWas,
                field: CoreFieldRefNames.State,
                value: parts[0]
            };
            const whenCondition: RuleCondition = {
                conditionType: RuleConditionType.When,
                field: CoreFieldRefNames.State,
                value: parts[1]
            };

            clientRule.conditions.splice(whenStateChangedFromAndToConditionIndex, 1, whenWasCondition, whenCondition);
        }
        else if (whenStateChangedToConditionIndex != null) {
            const whenChangedCondition: RuleCondition = {
                conditionType: RuleConditionType.WhenChanged,
                field: CoreFieldRefNames.State,
                value: null
            };
            const whenCondition: RuleCondition = {
                conditionType: RuleConditionType.When,
                field: CoreFieldRefNames.State,
                value: clientRule.conditions[whenStateChangedToConditionIndex].value
            };

            clientRule.conditions.splice(whenStateChangedToConditionIndex, 1, whenChangedCondition, whenCondition);
        }
        else if (whenWorkItemCreatedIndex != null) {
            const parts: string[] = clientRule.conditions[whenWorkItemCreatedIndex].value.split('.');
            const whenWasCondition: RuleCondition = {
                conditionType: RuleConditionType.WhenWas,
                field: CoreFieldRefNames.State,
                value: parts[0]
            };

            clientRule.conditions.splice(whenWorkItemCreatedIndex, 1, whenWasCondition);
        }

        for (let i = 0; i < clientRule.actions.length; i++) {
            const action = clientRule.actions[i];
            if (action.actionType === RuleActionType.SetValueToEmpty) {
                if (clientRule.actions.some(a => a.actionType === RuleActionType.MakeReadOnly && a.targetField === action.targetField)) {
                    continue;
                }

                action.actionType = RuleActionType.CopyValue;
                action.value = "";
            }
        }

        return clientRule;
    }

    export const translateServerRuleToClientRule = (serverRule : ProcessRule ): ProcessRule => {
        if (!serverRule.conditions) {
            return serverRule;
        }

        // clone before modification
        serverRule = CommonUtils.getClone<ProcessRule>(serverRule);

        let whenStateChangedConditionIndex: number = -1;
        let whenStateConditionIndex: number = -1;
        let whenStateWasConditionIndex: number = -1;

        for (let i = 0; i < serverRule.conditions.length; i++) {
            // Translation only affects conditions on state
            if (serverRule.conditions[i].field === CoreFieldRefNames.State) {
                switch (serverRule.conditions[i].conditionType) {
                    case RuleConditionType.When:
                        whenStateConditionIndex = i;
                        break;
                    case RuleConditionType.WhenChanged:
                        whenStateChangedConditionIndex = i;
                        break;
                    case RuleConditionType.WhenWas:
                        whenStateWasConditionIndex = i;
                        break;
                    // Else nothing to do
                }
            }
            else {
                const condition = serverRule.conditions[i];
                if (!condition.value) {
                    if (condition.conditionType === RuleConditionType.When) {
                        condition.conditionType = RuleConditionType.WhenValueIsNotDefined;
                    } else if (condition.conditionType === RuleConditionType.WhenNot) {
                        condition.conditionType = RuleConditionType.WhenValueIsDefined;
                    }
                }
            }
        }

        if (whenStateWasConditionIndex !== -1 && whenStateConditionIndex !== -1) {
            // '.' is not allowed in a state name, so we use it to cram in two values in our client side translation code
            // If we found both whenwas and when for state, those two conditions map to client option "when state changes from and to"
            const newClientOnlyCondition: RuleCondition = (!serverRule.conditions[whenStateWasConditionIndex].value)
                ? {
                    // We don't allow this in new rule engine, to support backcompat for rules created earlier we are keeping it.
                    conditionType: RuleConditionType.WhenWorkItemIsCreated,
                    field: CoreFieldRefNames.State,
                    value: serverRule.conditions[whenStateWasConditionIndex].value + "." + serverRule.conditions[whenStateConditionIndex].value
                } 
                : {
                    conditionType: RuleConditionType.WhenStateChangedFromAndTo,
                    field: CoreFieldRefNames.State,
                    value: serverRule.conditions[whenStateWasConditionIndex].value + "." + serverRule.conditions[whenStateConditionIndex].value
                };

            // Remove both old conditions. Remove largest index first, because removing the smaller index
            // would affect which item the larger index
            if (whenStateWasConditionIndex > whenStateConditionIndex) {
                serverRule.conditions.splice(whenStateWasConditionIndex, 1);
                serverRule.conditions.splice(whenStateConditionIndex, 1);
            }
            else {
                serverRule.conditions.splice(whenStateConditionIndex, 1);
                serverRule.conditions.splice(whenStateWasConditionIndex, 1);
            }

            // Add new client-only condition that replaces them
            serverRule.conditions = serverRule.conditions.concat(newClientOnlyCondition);
        }
        else if (whenStateChangedConditionIndex !== -1 && whenStateConditionIndex !== -1) {
            // If we found both whenchanged and when for state, those two conditions map to client option "when state changes to"
            const newClientOnlyCondition: RuleCondition = {
                conditionType: RuleConditionType.WhenStateChangedTo,
                field: CoreFieldRefNames.State,
                value: serverRule.conditions[whenStateConditionIndex].value
            };

            // Remove both old conditions. Remove largest index first, because removing the smaller index
            // would affect which item the larger index
            if (whenStateChangedConditionIndex > whenStateConditionIndex) {
                serverRule.conditions.splice(whenStateChangedConditionIndex, 1);
                serverRule.conditions.splice(whenStateConditionIndex, 1);
            }
            else {
                serverRule.conditions.splice(whenStateConditionIndex, 1);
                serverRule.conditions.splice(whenStateChangedConditionIndex, 1);
            }

            // Add new client-only condition that replaces them
            serverRule.conditions = serverRule.conditions.concat(newClientOnlyCondition);
        }
        else if (whenStateWasConditionIndex !== -1 && !serverRule.conditions[whenStateWasConditionIndex].value) {
            // Condition for WorkItemCreated Rule. (When State was "")
            const newClientOnlyCondition: RuleCondition = {
                conditionType: RuleConditionType.WhenWorkItemIsCreated,
                field: CoreFieldRefNames.State,
                value: serverRule.conditions[whenStateWasConditionIndex].value + "."
            };

            // Remove server side condition
            serverRule.conditions.splice(whenStateWasConditionIndex, 1);
            // Add new client-only condition that replaces them
            serverRule.conditions = serverRule.conditions.concat(newClientOnlyCondition);
        }

        for (let i = 0; i < serverRule.actions.length; i++) {
            const action = serverRule.actions[i];
            if (action.actionType === RuleActionType.CopyValue && (action.value == null || action.value === "")) {
                action.actionType = RuleActionType.SetValueToEmpty;
            }
            if (action.value === null) {
                action.value = "";
            }
        }
        return serverRule;
    }

    export const ruleValueContainsInvalidCharacters = (value: string): boolean => {
        return value && (StringUtils.containsControlChars(value) || StringUtils.containsMismatchedSurrogateChars(value));
    }
}

export namespace RuleFieldGroupings {
    export const getExplicitlyDeniedSystemFields = () => {
        const explicitlyDeniedSystemFields = [CoreFieldRefNames.Reason,
                                            CoreFieldRefNames.AreaPath,
                                            CoreFieldRefNames.IterationPath,
                                            CoreFieldRefNames.History,
                                            CoreFieldRefNames.Id,
                                            CoreFieldRefNames.IterationId,
                                            CoreFieldRefNames.NodeName,
                                            CoreFieldRefNames.Tags,
                                            CoreFieldRefNames.Watermark,
                                            CoreFieldRefNames.BoardColumn,
                                            CoreFieldRefNames.BoardColumnDone,
                                            CoreFieldRefNames.BoardLane,
                                            CoreFieldRefNames.CommentCount];
        return explicitlyDeniedSystemFields;
    }
    
    export const getFieldsExplicitlyDeniedFromWhenClauses = () => {
        const explicitlyDeniedFieldsFromWhenClauses = [CoreFieldRefNames.Rev,
                                                    CoreFieldRefNames.Parent,
                                                    OobFieldRefNames.StackRank];
        return explicitlyDeniedFieldsFromWhenClauses;
    }

    export const getFieldsExplicitlyDeniedFromThenClauses = () => {
        const explicitlyDeniedFieldsFromThenClauses = [CoreFieldRefNames.Rev,
                                                    CoreFieldRefNames.Parent,
                                                    CoreFieldRefNames.ExternalLinkCount,
                                                    CoreFieldRefNames.Parent,
                                                    CoreFieldRefNames.HyperLinkCount,
                                                    CoreFieldRefNames.AttachedFileCount,
                                                    CoreFieldRefNames.ChangedDate,
                                                    CoreFieldRefNames.Rev,
                                                    CoreFieldRefNames.ChangedBy,
                                                    CoreFieldRefNames.CreatedDate,
                                                    CoreFieldRefNames.CreatedBy,
                                                    CoreFieldRefNames.RelatedLinkCount,
                                                    CoreFieldRefNames.RemoteLinkCount,
                                                    CoreFieldRefNames.AuthorizedAs,
                                                    CoreFieldRefNames.AuthorizedDate,
                                                    CoreFieldRefNames.RevisedDate,
                                                    CoreFieldRefNames.TeamProject,
                                                    OobFieldRefNames.StackRank,
                                                    OobFieldRefNames.StateChangeDate,
                                                    OobFieldRefNames.ActivatedDate,
                                                    OobFieldRefNames.ActivatedBy,
                                                    OobFieldRefNames.ResolvedDate,
                                                    OobFieldRefNames.ResolvedBy,
                                                    OobFieldRefNames.ClosedDate,
                                                    OobFieldRefNames.ClosedBy];
        return explicitlyDeniedFieldsFromThenClauses;
    }

    export const getFieldsExplicitlyDeniedFromCopyFromRule = () => {
        const explicitlyDeniedFieldsFromCopyFromRule = [CoreFieldRefNames.Rev,
                                                        CoreFieldRefNames.Parent,
                                                        CoreFieldRefNames.ExternalLinkCount,
                                                        CoreFieldRefNames.HyperLinkCount,
                                                        CoreFieldRefNames.AttachedFileCount,
                                                        OobFieldRefNames.StackRank];
        return explicitlyDeniedFieldsFromCopyFromRule;
    }
}